var map = {
	"./ABC-orders": 36,
	"./ABC-orders.js": 36,
	"./EZM-orders": 37,
	"./EZM-orders.js": 37,
	"./constants": 24,
	"./constants.js": 24,
	"./development": 38,
	"./development.js": 38,
	"./local": 39,
	"./local.js": 39,
	"./production": 40,
	"./production.js": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;